import React from "react";

const Salerounds = ({
  saleRounds,
  setSaleRounds,
  saleRoundsErrors,
  setSaleRoundsErrors,
}) => {
  const addRound = () => {
    const newRound = {
      roundNumber: saleRounds.length + 1,
      roundPrice: 0,
      startDate: "",
      enddate: "",
    };

    setSaleRounds([...saleRounds, newRound]);

    // Add error tracking for new round
    setSaleRoundsErrors([
      ...saleRoundsErrors,
      {
        roundNumber: "",
        roundPrice: "",
        startDate: "",
        enddate: "",
      },
    ]);
  };

  const removeRound = (index) => {
    const filteredRounds = saleRounds.filter((_, i) => i !== index);
    const updatedRounds = filteredRounds.map((round, idx) => ({
      ...round,
      roundNumber: idx + 1,
    }));
    setSaleRounds(updatedRounds);

    // Remove error tracking for deleted round
    const updatedErrors = saleRoundsErrors.filter((_, i) => i !== index);
    setSaleRoundsErrors(updatedErrors);
  };

  const updateRoundPrice = (index, price) => {
    if (!/^\d*\.?\d*$/.test(price)) return;

    setSaleRounds((prev) =>
      prev.map((round, i) =>
        i === index
          ? {
              ...round,
              roundPrice: price,
            }
          : round
      )
    );

    // Clear error for this field
    if (saleRoundsErrors[index]?.roundPrice) {
      clearError(index, "roundPrice");
    }
  };

  const updateStartDate = (index, startDate) => {
    console.log("Updating start date for index:", index, "to:", startDate);

    setSaleRounds((prev) => {
      const updated = prev.map((round, i) => {
        if (i === index) {
          console.log("Found matching round at index:", i);
          return { ...round, startDate };
        }
        return round;
      });
      console.log("Updated rounds:", updated);
      return updated;
    });

    // Clear error for this field
    if (saleRoundsErrors[index]?.startDate) {
      clearError(index, "startDate");
    }
  };

  const updateEndDate = (index, enddate) => {
    console.log("Updating end date for index:", index, "to:", enddate);

    setSaleRounds((prev) => {
      const updated = prev.map((round, i) => {
        if (i === index) {
          console.log("Found matching round at index:", i);
          return { ...round, enddate };
        }
        return round;
      });
      console.log("Updated rounds:", updated);
      return updated;
    });

    // Clear error for this field
    if (saleRoundsErrors[index]?.enddate) {
      clearError(index, "enddate");
    }
  };

  // Helper to clear individual field errors
  const clearError = (index, field) => {
    const updatedErrors = [...saleRoundsErrors];
    if (updatedErrors[index]) {
      updatedErrors[index] = {
        ...updatedErrors[index],
        [field]: "",
      };
      setSaleRoundsErrors(updatedErrors);
    }
  };

  // Format date for datetime-local input (local timezone)
  const formatDateToLocal = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    // Get local time components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  // Convert local datetime to ISO string
  const formatLocalToISO = (localDate) => {
    if (!localDate) return "";
    const date = new Date(localDate);
    return date.toISOString();
  };

  return (
    <>
      <div className="parentsteps">
        <section className="laststeps">
          <h2>
            Project Rounds
            {/* <span>(Optional)</span>{" "} */}
          </h2>
          <div>
            {saleRounds.map((r, index) => (
              <div className="crossbutton" key={index}>
                <div className="bottom_fifth">
                  <div className="top_two_sides">
                    <div className="div_rounds">
                      <h5>Round</h5>
                      <div className="textual_div latesstt">
                        <h4>{"Round " + r.roundNumber}</h4>
                      </div>
                      {saleRoundsErrors[index]?.roundNumber && (
                        <span className="error-text">
                          {saleRoundsErrors[index].roundNumber}
                        </span>
                      )}
                    </div>
                    <div className="div_rounds">
                      <h5>Round Price</h5>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={r.roundPrice === 0 ? "" : r.roundPrice}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value) || value === "") {
                            updateRoundPrice(index, value);
                          }
                        }}
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (value === "" || isNaN(parseFloat(value))) {
                            updateRoundPrice(index, "0");
                          }
                        }}
                        placeholder="0.0"
                        className={
                          saleRoundsErrors[index]?.roundPrice
                            ? "error-input"
                            : ""
                        }
                      />
                      {saleRoundsErrors[index]?.roundPrice && (
                        <span className="error-text">
                          {saleRoundsErrors[index].roundPrice}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="datter_timmer_div">
                    <div className="datetimmme">
                      <h5>Start Date</h5>
                      <input
                        value={formatDateToLocal(r.startDate)}
                        onChange={(e) =>
                          updateStartDate(
                            index,
                            formatLocalToISO(e.target.value)
                          )
                        }
                        type="datetime-local"
                        placeholder="15/07/2025"
                        className={
                          saleRoundsErrors[index]?.startDate
                            ? "error-input"
                            : ""
                        }
                      />
                      {saleRoundsErrors[index]?.startDate && (
                        <span className="error-text">
                          {saleRoundsErrors[index].startDate}
                        </span>
                      )}
                    </div>
                    <div className="datetimmme">
                      <h5>End Date</h5>
                      <input
                        value={formatDateToLocal(r.enddate)}
                        onChange={(e) =>
                          updateEndDate(index, formatLocalToISO(e.target.value))
                        }
                        type="datetime-local"
                        placeholder="15/07/2025"
                        className={
                          saleRoundsErrors[index]?.enddate ? "error-input" : ""
                        }
                      />
                      {saleRoundsErrors[index]?.enddate && (
                        <span className="error-text">
                          {saleRoundsErrors[index].enddate}
                        </span>
                      )}
                    </div>
                    <div className="crrooosicon">
                      {index !== 0 && (
                        <img
                          src="\assets\cross.svg"
                          alt="remove"
                          className="cursor-pointer"
                          onClick={() => removeRound(index)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <button onClick={addRound} className="mt-4 flex items-center gap-2">
              Add another
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5 10H15"
                  stroke="#02171D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10 15V5"
                  stroke="#02171D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </section>
      </div>
    </>
  );
};

export default Salerounds;
